module.exports = __webpack_public_path__ + "img/phone.73a91f17.png";